<template>
  <div>
    <v-tooltip
    left
    open-delay="500"
    >
    <template v-slot:activator="{ on, attrs }">
      <span
          v-bind="attrs"
          v-on="on"
          @click="dialog = true"
          style="cursor: help"
        >
          {{ Helpers.formatarValor(item.percentual) }} %
        </span>
      </template>

      <span>
        <p class="my-0">Clique para editar a influencia da projeção</p>
        <p class="mt-4 mb-0 subtitle-1" v-if="item.data_limite">Informações Adicionais:</p>
        <p class="mb-0" v-if="item.data_limite">Data Limite: {{ item.data_limite }}</p>
      </span>
    </v-tooltip>

    <SysDialog
      v-model="dialog"
      :titulo="TITULO_DIALOG"
      :largura="LARGURA_DIALOG"
      @click:primary="editar()"
    >
      <p v-if="produtos_selecionados.length > 0">
        <v-icon color="orange">mdi-alert</v-icon>
        A alteração será aplicada aos itens previamente marcados.
      </p>

      <v-text-field
        v-model="editar_item.data_limite"
        label="Data Limite*"
        type="date"
        class="mb-3"
        messages="Data de vencimento do fator de atuação"
        outlined
        :error-messages="DATA_LIMITE_ERRORS"
        @input="$v.editar_item.data_limite.$touch()"
        @blur="$v.editar_item.data_limite.$touch()"
      />

      <v-select
        outlined
        v-model="editar_item.tipo_ajuste"
        :items="tipo_ajuste"
        label="Selecione o Tipo de Ajuste*"
        item-value="id"
        item-text="tipo"
        :error-messages="TIPO_AJUSTE_ERRORS"
        @input="$v.editar_item.tipo_ajuste.$touch()"
        @blur="$v.editar_item.tipo_ajuste.$touch()"
      />

      <v-text-field
        v-model="editar_item.percentual_ajuste"
        label="Informe o Percentual*"
        placeholder="Ex: 50"
        suffix="%"
        outlined
        :error-messages="PERCENTUAL_AJUSTE_ERRORS"
        @input="$v.editar_item.percentual_ajuste.$touch()"
        @blur="$v.editar_item.percentual_ajuste.$touch()"
      />
    </SysDialog>
  </div>
</template>

<script>
import TextFieldFormatadorDeValor from '@/components/utils/TextFieldFormatadorDeValor.vue';
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import { required, decimal } from "vuelidate/lib/validators";
import { editarInfluenciarProjecao } from "../Api";
import moment from 'moment';

export default {
  components: {
    SysDialog,
    TextFieldFormatadorDeValor
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    produtos_selecionados: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    dialog: false,
    editar_item: {
      data_limite: '',
      tipo_ajuste: '',
      percentual_ajuste: ''
    },
    tipo_ajuste: [
      { id: 1, tipo: "Aumento" },
      { id: 2, tipo: "Redução" },
    ],
  }),
  validations: {
    editar_item: {
      data_limite: {
        required,
        posteriorHoje() {
          const hoje = new Date().getTime();
          const data = new Date(this.editar_item.data_limite).getTime();

          if (hoje >= data) return false;
          return true;
        }
      },
      tipo_ajuste: { required },
      percentual_ajuste: {
        required,
        decimal,
        ajusteValido () {
          if (this.editar_item.tipo_ajuste == 2 && this.editar_item.percentual_ajuste >= 100) return false;
          return true;
        },
      },
    }
  },
  watch: {
    dialog(valor) {
      if (valor) {
        this.editar_item.data_limite = moment(this.item.data_limite, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
    }
  },
  computed: {
    TITULO_DIALOG() {
      return 'Editar influenciar projeção';
    },
    LARGURA_DIALOG() {
      return 450;
    },
    DATA_LIMITE_ERRORS() {
      const errors = [];
      if (!this.$v.editar_item.data_limite.$dirty) return errors;
      !this.$v.editar_item.data_limite.required && errors.push("Campo Obrigatório.");
      !this.$v.editar_item.data_limite.posteriorHoje && errors.push("Data limite deve ser posterior a hoje.");
      return errors;
    },
    TIPO_AJUSTE_ERRORS() {
      const errors = [];
      if (!this.$v.editar_item.tipo_ajuste.$dirty) return errors;
      !this.$v.editar_item.tipo_ajuste.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    PERCENTUAL_AJUSTE_ERRORS() {
      const errors = [];
      if (!this.$v.editar_item.percentual_ajuste.$dirty) return errors;
      !this.$v.editar_item.percentual_ajuste.required && errors.push("Campo Obrigatório.");
      !this.$v.editar_item.percentual_ajuste.ajusteValido && errors.push("Redução máxima é de 99%.");
      return errors;
    }
  },
  methods: {
    editar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let parametros = {
          ...this.editar_item,
          grupo: this.item.id_grupo,
          filial: this.item.filial,
          produtos: []
        };

        parametros.produtos = this.produtos_selecionados.length == 0 ? [this.item] : this.produtos_selecionados;

        this.$store.dispatch(
          'loading/addRequisicao',
          editarInfluenciarProjecao(parametros)
            .then(() => {
              this.$emit('atualizar-tela-inicial');
              this.dialog = false;
            })
            .catch(() => this.Helpers.logout())
        );
      }
    }
  }
}
</script>

<style>

</style>
